import { post,put,del,get } from './axios'

// 공지사항의 CRUD를 나열
export const insertQuestion = async (params) => {
  const { status, data } = await post("/qna/insertQuestionAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const checkPassWord = async (params) => {
  const { status, data } = await post("/qna/checkPassWordAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

//질문게시판 조회 
export const qnaList = async (params) => {
  const { status, data } = await get("/qna/selectQuestionListAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}
// 질문게시판 상세조회
export const qnaDetail = async (params) => {
  const { status, data } = await get("/qna/questionDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

// 질문게시판 상세조회 페이지 속 댓글 조회
export const answerList = async (params) => {
  const { status, data } = await get("/qna/selectAnswerListAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
} 
